var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePasswordEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.346667 504.533333l121.813333-121.813333a128 128 0 0 0-121.813333 121.813333z m238.72-57.6L576 495.786667a64 64 0 0 1-76.8 76.8l-48.853333 48.853333a128 128 0 0 0 174.506666-174.506667z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.013333 512a21.333333 21.333333 0 0 1 6.186667-15.146667c139.52-139.306667 268.8-207.146667 396.8-207.146666a372.266667 372.266667 0 0 1 79.786667 8.96l52.266666-52.266667a443.52 443.52 0 0 0-132.053333-21.333333c-145.92 0-291.84 75.306667-442.453333 225.92a85.333333 85.333333 0 0 0 0 120.746666 1063.04 1063.04 0 0 0 134.186666 115.2l45.866667-45.866666a985.813333 985.813333 0 0 1-134.4-114.133334 21.333333 21.333333 0 0 1-6.186667-14.933333z m845.653334-60.373333a966.613333 966.613333 0 0 0-185.813334-149.333334l-46.72 46.72a877.653333 877.653333 0 0 1 187.306667 147.2 21.333333 21.333333 0 0 1 0 30.08C770.133333 666.453333 640 734.293333 512 734.293333a393.386667 393.386667 0 0 1-145.706667-29.013333l-48.64 48.64A466.133333 466.133333 0 0 0 512 798.293333c145.92 0 291.84-75.306667 442.453333-225.92a85.333333 85.333333 0 0 0 0.213334-120.746666z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M777.267604 203.950713m22.627417 22.627417l0 0q22.627417 22.627417 0 45.254834l-527.973064 527.973063q-22.627417 22.627417-45.254834 0l0 0q-22.627417-22.627417 0-45.254834l527.973064-527.973063q22.627417-22.627417 45.254834 0Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordEye);
export default __webpack_public_path__ + "static/media/hidePasswordEye.ffd2bbd0717197e32a8ec8f1dc0b338f.svg";
export { ForwardRef as ReactComponent };